import { parseIsoDate } from '@/utils/common'
import { Translator } from '../../types/ApiResponseTypes'
import { InvoiceResponse, isInvoiceListResponse } from '../../types/invoice/InvoiceResponse'
import { Invoice, InvoiceList } from '../../types/invoice/InvoiceType'

class InvoiceResponseTranslator implements Translator<InvoiceList> {
  convert(response: any): InvoiceList {
    if (isInvoiceListResponse(response)) {
      const invoiceObject: Array<Invoice> = []
      const rawInvoices = response.data?.invoices ?? response.invoices

      if (Array.isArray(rawInvoices)) {
        rawInvoices.forEach((invoice: InvoiceResponse) => {
          invoiceObject.push(this.convertToInvoiceModel(invoice))
        })
        return {
          total: response.data?.total ?? response.total,
          page: response.data?.page ?? response.page,
          invoices: invoiceObject,
          meta: response.meta?.DetailDownloadFormats ?? [],
        }
      }
    }
    return { total: 0, page: 0, invoices: [], meta: [] }
  }

  convertToInvoiceModel(response: InvoiceResponse): Invoice {
    return {
      id: response.id,
      invoiceNr: String(response.invoiceNr),
      name: response.name,
      date: parseIsoDate(response.issueDate),
      duedate: parseIsoDate(response.dueDate),
      type: response.type,
      totalIncVat: response.totalAmount.total,
      totalExcVat: response.totalAmount.beforeTax,
      openIncVat: response.remainingAmount.total,
      openExcvat: response.remainingAmount.beforeTax ?? response.remainingAmount.total,
      status: response.status,
      statusId: response.status,
      cdrAvailable: response.cdrAvailable === 1,
      source: 'snappy',
    }
  }
}
export default new InvoiceResponseTranslator()
